import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import { composeWithDevTools } from 'redux-devtools-extension';
import storage from 'redux-persist/lib/storage';
import rootReducer from '../redux/reducers/root/root.reducer';
import STORAGE_CONSTANTS from '../constants/storage.constants';

const persistConfig = {
  key: 'user',
  storage,
  whitelist: ['auth'],
};
const storeReducer = persistReducer(persistConfig, rootReducer);
const store = createStore(storeReducer, composeWithDevTools(applyMiddleware(thunkMiddleware)));
const persistor = persistStore(store);
if (!localStorage.getItem(STORAGE_CONSTANTS.TOKEN_KEY)) {
  // Only persist auth info if other session storage vars are still present
  persistor.purge();
}

export { store, persistor };
